import {
  useMemo,
  useState,
  useEffect,
  useRef,
  Dispatch,
  SetStateAction,
  useLayoutEffect,
  memo,
} from 'react';
import GroupLogo from '../../../assets/images/ranking_title_2026/GroupLogo.png';
import VerticalLine from '../../../assets/images/ranking_title_2026/Vertical Line.png';

import { useAppSelector } from '../../../hooks';
import { IMAGE_BASE_URL_OF_USER_RANK } from '../../../constants';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import { useWindowSize } from '../../../components/Common/UseWindowSize';
import HorizontalSplitLine from '../../../assets/images/ranking_title_split_2026/LINE.png';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

import {
  appointeeNoOrder,
  appointeeSubtitleTop10,
  dayAppointeeTitle,
  daySaleTitle,
  isImage,
  isVideo,
  monthAppointeeTitle,
  monthSaleTitle,
  saleNoOrder,
  saleSubtitleTop10,
} from 'helpers/functionHelper';
import moment from 'moment';
import { DisplayScreenType, NoteAppRankingTypes, NoteStyleConfig } from 'models';
import { useAutoFontSize } from 'hooks/useAutoFontSize';
// swiper modules: Autoplay, pagination
SwiperCore.use([Autoplay]);
interface LayoutRowProps {
  displayData: any;
  nameRunning: any;
  setCurrentRankingItemRunning: Dispatch<SetStateAction<number>>;
  setCurrentTypeDisplayOnScreen: Dispatch<SetStateAction<DisplayScreenType>>;
  currentRankingItemRunning: number;
}
type RankingName = 'PROFIT_DAY' | 'PROFIT_MONTH' | 'NOMINATION_DAY' | 'NOMINATION_MONTH';
type RankingKey =
  | 'disable_profit_day'
  | 'disable_profit_month'
  | 'disable_nomination_day'
  | 'disable_nomination_month';
const LayoutRow: React.FC<LayoutRowProps> = ({
  displayData,
  nameRunning,
  setCurrentRankingItemRunning,
  setCurrentTypeDisplayOnScreen,
  currentRankingItemRunning,
}: LayoutRowProps) => {
  const { width, height } = useWindowSize();
  const { recalc, register } = useAutoFontSize();

  const keysByRankingName: Record<RankingName, RankingKey> = {
    PROFIT_DAY: 'disable_profit_day',
    PROFIT_MONTH: 'disable_profit_month',
    NOMINATION_DAY: 'disable_nomination_day',
    NOMINATION_MONTH: 'disable_nomination_month',
  };

  const swiperRef = useRef<any>(null);
  const shopList = useAppSelector((state) => state.shopList.listShop);
  const selectedShop = useAppSelector((state) => state.shopList.selectShop);
  const selectShop =
    shopList.find((item) => item.id === displayData?.object[currentRankingItemRunning]?.shop_id) ||
    selectedShop;
  // const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const noteAppRanking = useAppSelector((state) => state.ranking.noteAppRanking);
  const noteStaffAppRanking = useAppSelector((state) => state.ranking.noteStaffAppRanking);
  const orderByImagesSliderRank = useAppSelector((state) => state.ranking.orderByImagesSliderRank);

  const [realSlideIndex, setRealSlideIndex] = useState<number>(0);

  const [imageError, setImageError] = useState<{ [key: string]: boolean }>({});
  const [showSlide, setShowSlide] = useState(true);
  const max = displayData?.object?.length || 1;

  const shopInfoRanking = (shopItem: any) => {
    const shopFound = shopList.find((item) => item.id === shopItem?.shop_id);

    return shopFound;
  };
  // check select shop is in stardam group
  const checkShopStardamGroup = useMemo(
    () => (selectShop as any)?.group_shop === 1,
    [selectShop?.id]
  );

  const autoplayDelay =
    Number(displayData?.object[currentRankingItemRunning]?.secondChange) * 1000 || 30000;

  // for testing
  // const autoplayDelay = 1000000000;

  const dataSort = useMemo(() => {
    if (!displayData?.object?.length) return [];

    const currentSlide = displayData.object[realSlideIndex];

    if (!currentSlide?.relatedItems?.length) return [];

    return currentSlide.relatedItems;
  }, [displayData?.object, realSlideIndex]);

  const top1 = useMemo(() => {
    return dataSort.slice(0, 1)[0];
  }, [dataSort]);
  const top2_3 = useMemo(() => {
    return dataSort.slice(1, 3);
  }, [dataSort]);
  const top4_5 = useMemo(() => {
    return dataSort.slice(3, 5);
  }, [dataSort]);
  const top6_7 = useMemo(() => {
    return dataSort.slice(5, 7);
  }, [dataSort]);
  const top8_9_10 = useMemo(() => {
    return dataSort.slice(7, 10);
  }, [dataSort]);

  const nextLayout = displayData.object[currentRankingItemRunning + 1]?.infoItem?.link
    ? 0
    : (displayData.object[currentRankingItemRunning + 1]?.layout_ranking ?? 0);

  // functions

  const __renderTitleByNameRunning = () => {
    const nameRunningMap = {
      PROFIT_DAY: daySaleTitle,
      PROFIT_MONTH: monthSaleTitle[moment().month() + 1],
      NOMINATION_DAY: dayAppointeeTitle,
      NOMINATION_MONTH: monthAppointeeTitle[moment().month() + 1],
    };
    return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
  };

  const __renderSubTitleByNameRunning = () => {
    const nameRunningMap = {
      PROFIT_DAY: saleSubtitleTop10,
      PROFIT_MONTH: saleSubtitleTop10,
      NOMINATION_DAY: appointeeSubtitleTop10,
      NOMINATION_MONTH: appointeeSubtitleTop10,
    };
    return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
  };
  const __renderNumberOrderByNameRunning = (idx: number) => {
    const nameRunningMap = {
      PROFIT_DAY: saleNoOrder[idx],
      PROFIT_MONTH: saleNoOrder[idx],
      NOMINATION_DAY: appointeeNoOrder[idx],
      NOMINATION_MONTH: appointeeNoOrder[idx],
    };
    return nameRunningMap[nameRunning as keyof typeof nameRunningMap];
  };

  const handleImageError = (idHost: string) => {
    setImageError((prev) => ({ ...prev, [idHost]: true }));
  };
  const getShowRankingTop = (item: any) => {
    let index: number = noteAppRanking.findIndex((note: any) => note?.rank === item?.rank);

    const key = keysByRankingName[nameRunning as RankingName];
    if (index !== -1) {
      return noteAppRanking[index]?.[key || 'disable_nomination_month'];
    }
    return 0;
  };

  const getNoteRankingByHost = (item: any) => {
    return (
      noteStaffAppRanking.find(
        (noteItem: any) =>
          !noteItem.order_by_image_slider_ranking_id &&
          noteItem?.user_id === item?.id &&
          noteItem?.note
      )?.note || ''
    );
  };

  // from No1 to No10 (15/1/2026) => future can be from No1 to No + number
  const getNoteRankingByRankOrder = (item: any) => {
    return (
      noteAppRanking.find(
        (noteItem: any) =>
          !noteItem.order_by_image_slider_ranking_id &&
          noteItem?.shop_id === selectShop?.id &&
          noteItem?.rank === item?.rank &&
          noteItem?.note
      )?.note || ''
    );
  };

  const getStyleConfig = (
    noteItem?: Partial<NoteAppRankingTypes> | null
  ): NoteStyleConfig | null => {
    if (!noteItem?.font) {
      return null;
    }

    return {
      font: noteItem.font || 'NotoSansNormal',
      font_size: noteItem.font_size || 40,
      color: noteItem.color || '#E9EAEB',
      stroke_color: noteItem.stroke_color || '#252B37',
      stroke_width: noteItem.stroke_width || 10,
    };
  };

  const _renderRank = ({
    name,
    id,
    img,
    rank,
    style,
    noteRanking,
  }: {
    name: string;
    id: string;
    img: string;
    rank: string;
    style: any;
    noteRanking: any;
  }) => {
    const noteByHost = getNoteRankingByHost(noteRanking);
    const noteRankingOrder = getNoteRankingByRankOrder(noteRanking);
    const noteStyleByHost = noteStaffAppRanking.find(
      (noteItem: any) =>
        !noteItem.order_by_image_slider_ranking_id &&
        noteItem?.user_id === noteRanking?.id &&
        noteItem?.note
    );
    const noteStyleByRankingOrderBy = noteAppRanking
      .filter((noteItem: any) => !noteItem.user_id)
      .find(
        (noteItem: any) =>
          !noteItem.order_by_image_slider_ranking_id &&
          noteItem?.rank === noteRanking?.rank &&
          noteItem?.note
      );
    const styleConfigNoteByHost = getStyleConfig(noteStyleByHost);
    const styleConfigNoteByRankingOrderBy = getStyleConfig(noteStyleByRankingOrderBy);
    const isSquareView = width == height;
    return (
      <div className="flex overflow-hidden relative w-full h-full">
        {imageError[id] ? (
          <div className="w-full h-full" />
        ) : (
          <img
            className={`object-cover w-full h-full`}
            src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_rank/${img}?ts=${Date.now()}`}
            onError={() => {
              handleImageError(id);
            }}
          />
        )}
        <div className="absolute bottom-0">
          {checkShopStardamGroup ? (
            // old layout, do not delete
            // <div className="flex justify-between items-center w-full">
            //   <div className="flex flex-col pl-5">
            //     <span
            //       style={{
            //         color: '#FFFFFF',
            //         textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
            //         fontSize: style.sizeTextName,
            //       }}
            //       className="leading-none whitespace-nowrap notoserif_black"
            //     >
            //       {name}
            //     </span>
            //     <div style={{ marginTop: position ? 20 : 0 }}>
            //       <span
            //         style={{
            //           color: '#FFFFFF',
            //           textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
            //           fontSize: style.sizeTextPosition,
            //         }}
            //         className="leading-none whitespace-nowrap hiragino"
            //       >
            //         {position}
            //       </span>
            //     </div>
            //   </div>
            //   <img
            //     src={rankingNumberOrderStardamGroupTitle[rank]}
            //     alt=""
            //     className="w-1/2 border-none"
            //     style={{
            //       scale: style?.scale,
            //       paddingRight: style.paddingRight ? style.paddingRight : 0,
            //       paddingBottom: style.paddingBottom ? style.paddingBottom : 0,
            //     }}
            //   />
            // </div>

            <div>
              {/* get top 1 -> 3 */}
              {Array.from({ length: 3 }, (_, i) => `No.${i + 1}`).includes(rank) ? (
                <div className="flex items-end max-w-full w-fit">
                  <div className="flex flex-col max-w-[50%] w-full gap-5 pb-10 pl-10">
                    <span
                      style={{
                        color: '#FFFFFF',
                        textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                        fontSize: style.sizeTextName,
                      }}
                      className="leading-none line-clamp-1 notoserif_black text-ellipsis"
                    >
                      {name}
                    </span>
                    <div className="flex flex-col gap-y-3">
                      {/* {!styleConfigNoteByHost ? ( */}
                      {true ? (
                        <span
                          style={{
                            color: '#FFFFFF',
                            textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                            fontSize: style.sizeTextPosition,
                          }}
                          className="leading-none line-clamp-1 hiragino text-ellipsis"
                        >
                          {noteByHost}
                        </span>
                      ) : (
                        // <span
                        //   className="line-clamp-1 text-ellipsis"
                        //   style={{
                        //     fontFamily: styleConfigNoteByHost.font,
                        //     fontSize: `${Math.min(styleConfigNoteByHost.font_size, 40)}px`,
                        //     color: styleConfigNoteByHost.color,
                        //   }}
                        // >
                        //   {noteByHost}
                        // </span>
                        <></>
                      )}
                      {/* {!styleConfigNoteByRankingOrderBy ? ( */}
                      {true ? (
                        <span
                          style={{
                            color: '#FFFFFF',
                            textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                            fontSize: style.sizeTextPosition,
                          }}
                          className="leading-none line-clamp-1 hiragino text-ellipsis"
                        >
                          {noteRankingOrder}
                        </span>
                      ) : (
                        // <span
                        //   className="line-clamp-1 text-ellipsis"
                        //   style={{
                        //     fontFamily: styleConfigNoteByRankingOrderBy.font,
                        //     fontSize: `${Math.min(styleConfigNoteByRankingOrderBy.font_size, 40)}px`,
                        //     color: styleConfigNoteByRankingOrderBy.color,
                        //   }}
                        // >
                        //   {noteRankingOrder}
                        // </span>
                        <></>
                      )}
                    </div>
                  </div>
                  <img
                    src={__renderNumberOrderByNameRunning(Number(rank.split('.')[1]))}
                    alt=""
                    className="max-w-[50%] w-full border-none h-fit"
                    style={{
                      scale: style?.scale,
                      paddingRight: style.paddingRight ? style.paddingRight : 0,
                      paddingBottom: style.paddingBottom ? style.paddingBottom : 0,
                    }}
                  />
                </div>
              ) : (
                // else 4 -> 10
                <div className="pb-10 pl-10 space-y-1 w-full h-full">
                  <img
                    src={__renderNumberOrderByNameRunning(Number(rank.split('.')[1]))}
                    alt=""
                    className="object-contain w-full h-10 border-none"
                    style={{
                      objectPosition: '-20px 0',
                    }}
                  />
                  <div className="h-full w-fit">
                    <span
                      style={{
                        color: '#FFFFFF',
                        textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                        fontSize: style.sizeTextName,
                      }}
                      className="leading-none notoserif_black line-clamp-1 text-ellipsis"
                    >
                      {name}
                    </span>
                    <div>
                      {/* {!styleConfigNoteByHost ? ( */}
                      {true ? (
                        <div
                          style={{
                            color: '#FFFFFF',
                            textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                            fontSize: style.sizeTextPosition,
                          }}
                          className="hiragino line-clamp-1 text-ellipsis"
                        >
                          {noteByHost}
                        </div>
                      ) : (
                        // <span
                        //   className="truncate"
                        //   style={{
                        //     fontFamily: styleConfigNoteByHost.font,
                        //     fontSize: `${Math.min(styleConfigNoteByHost.font_size, 40)}px`,
                        //     color: styleConfigNoteByHost.color,
                        //   }}
                        // >
                        //   {noteByHost}
                        // </span>
                        <></>
                      )}
                      {/* {!styleConfigNoteByRankingOrderBy ? ( */}
                      {true ? (
                        <div
                          style={{
                            color: '#FFFFFF',
                            textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                            fontSize: style.sizeTextPosition,
                          }}
                          className="hiragino line-clamp-1 text-ellipsis"
                        >
                          {noteRankingOrder}
                        </div>
                      ) : (
                        // <span
                        //   className="truncate"
                        //   style={{
                        //     fontFamily: styleConfigNoteByRankingOrderBy.font,
                        //     fontSize: `${Math.min(styleConfigNoteByRankingOrderBy.font_size, 40)}px`,
                        //     color: styleConfigNoteByRankingOrderBy.color,
                        //   }}
                        // >
                        //   {noteRankingOrder}
                        // </span>
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col justify-center text-white">
              <span
                style={{
                  color: '#FFFFFF',
                  textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                  fontSize: style.sizeTextName,
                }}
                className="leading-none whitespace-nowrap notoserif_black"
              >
                {name}
              </span>
              <div style={{ marginTop: noteRankingOrder ? 20 : 0 }}>
                <span
                  style={{
                    color: '#FFFFFF',
                    textShadow: ` -0.5px -0.5px 0 #364152, 0.5px -0.5px 0 #364152,-0.5px  0.5px 0 #364152,0.5px  0.5px 0 #364152`,
                    fontSize: style.sizeTextPosition,
                  }}
                  className="leading-none whitespace-nowrap hiragino"
                >
                  {noteRankingOrder}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const __renderStandByImage = (imageData: any) => {
    let finalImageLink = '';
    if (
      typeof imageData?.infoItem?.images_slider_id == 'number' &&
      imageData?.infoItem?.images_slider_id !== 0
    ) {
      finalImageLink = imageData?.infoItem?.images_slider?.link;
    } else {
      finalImageLink = imageData?.infoItem?.link;
    }
    return (
      <>
        {finalImageLink?.includes('.mp4') ? (
          <video
            id={`myVideo${imageData.id}`}
            controls={false}
            width="100%"
            className={`object-contain w-full h-full`}
            autoPlay
            loop={true}
          >
            <source
              src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${finalImageLink}`}
              type="video/mp4"
            />
          </video>
        ) : (
          <img
            src={`${IMAGE_BASE_URL_OF_USER_RANK}/images_slider/${finalImageLink}`}
            className={`object-contain w-full h-full`}
          />
        )}
      </>
    );
  };

  // use effects
  const nextLayoutRef = useRef(nextLayout);
  useEffect(() => {
    nextLayoutRef.current = nextLayout;
  }, [nextLayout]);
  useEffect(() => {
    const currentItem = displayData?.object?.[realSlideIndex];

    let nextType: DisplayScreenType = '';

    if (!currentItem) {
      setCurrentTypeDisplayOnScreen('');
      return;
    }

    // 1. Video
    if (isVideo(currentItem)) {
      nextType = 'stand-by-video';
    }
    // 2. Image
    else if (isImage(currentItem)) {
      nextType = 'stand-by-image';
    }
    // 3. Ranking by date or month
    else if (Array.isArray(currentItem?.relatedItems) && currentItem.relatedItems.length > 0) {
      if (currentItem.type === 'month') {
        nextType = 'ranking-month';
      } else if (currentItem.type === 'date') {
        nextType = 'ranking-day';
      }
    }

    setCurrentTypeDisplayOnScreen(nextType);
  }, [realSlideIndex, displayData?.object]);

  useEffect(() => {
    const swiper = swiperRef.current;
    if (!swiper) return;
    if (swiper.params?.autoplay) {
      swiper.params.autoplay.delay = autoplayDelay;
      swiper.autoplay.stop();
      swiper.autoplay.start();
    }
  }, [autoplayDelay]);

  useLayoutEffect(() => {
    const swiper = swiperRef.current;
    if (!swiper) return;

    if (swiper.realIndex === currentRankingItemRunning) return;

    swiper.slideToLoop(currentRankingItemRunning, 0);
  }, [currentRankingItemRunning]);

  useLayoutEffect(() => {
    const t = setTimeout(() => {
      recalc();
    }, 100);

    return () => clearTimeout(t);
  }, [currentRankingItemRunning, recalc]);

  return (
    <div className="w-full h-full layoutRow_carousel">
      <div style={{ opacity: showSlide ? 1 : 0 }}>
        <Swiper
          // key={currentRankingItemRunning}
          ref={swiperRef}
          speed={300}
          slidesPerView={1}
          autoplay={{
            delay: autoplayDelay,
            disableOnInteraction: false,
          }}
          loop={true}
          onSwiper={(swiper) => {
            if (swiper) {
              swiperRef.current = swiper;
              setRealSlideIndex(swiper.realIndex);
            }
          }}
          // onBeforeTransitionStart={(swiper) => {
          //   if (nextLayout == 1) {
          //     swiper.wrapperEl.style.transitionDuration = '.5ms';
          //   }
          // }}
          onBeforeTransitionStart={(swiper) => {
            if (nextLayoutRef.current === 1) {
              swiper.wrapperEl.style.transitionDuration = '0.5ms';
              setShowSlide(false);
            } else {
              swiper.wrapperEl.style.transitionDuration = '300ms';
            }
          }}
          onAfterInit={() => {
            if (!displayData?.object) return;

            const firstItem = displayData.object[0];
            const isFirstVideo = firstItem?.infoItem?.link?.includes('.mp4');

            displayData.object.forEach((item: any, idx: number) => {
              const isVideo = item?.infoItem?.link?.includes('.mp4');
              const videoEl = document.getElementById(
                `myVideo${item.id}`
              ) as HTMLVideoElement | null;

              if (!isVideo || !videoEl) return;

              if (idx === 0 && isFirstVideo) {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    videoEl.play().catch(() => {});
                  }, 0);
                });
                return;
              }

              videoEl.pause();
            });
          }}
          onSlideChangeTransitionEnd={(swiper) => {
            const rawIndex = swiper.realIndex;
            const safeIndex = rawIndex % max;
            setCurrentRankingItemRunning(safeIndex);
            setRealSlideIndex(safeIndex);
            setShowSlide(true);

            const currentSlide = displayData?.object?.[safeIndex];

            // play video of current slide
            if (currentSlide?.infoItem?.link?.includes('.mp4')) {
              const videoEl = document.getElementById(
                `myVideo${currentSlide.id}`
              ) as HTMLVideoElement | null;

              if (videoEl) {
                videoEl.currentTime = 0;

                requestAnimationFrame(() => {
                  setTimeout(() => {
                    videoEl.play().catch(() => {});
                  }, 0);
                });
              }
            }
          }}
        >
          {displayData?.object?.map((x: any, y: number) => {
            // if (y !== displayData.subIndex) return null;

            return (
              <SwiperSlide key={`slide-${y}`}>
                {checkShopStardamGroup &&
                  Array.isArray(x?.relatedItems) &&
                  x.relatedItems.length > 0 && (
                    <div
                      className={`flex justify-end items-center py-2  lg:mx-auto  ${Math.abs(width - height) < 500 ? 'w-full h-[120px]' : 'w-1/2 h-[95px]'} `}
                    >
                      <div className="flex flex-col justify-between items-end pt-1 h-full w-fit">
                        <img src={GroupLogo} alt="Group Stardam" className="object-contain h-10" />
                        <p
                          ref={register(16, 20)}
                          className="w-full font-hgs-minchoE text-[#FFF691] whitespace-nowrap text-right leading-none"
                        >
                          {shopInfoRanking(displayData?.object[currentRankingItemRunning])?.name}
                        </p>
                      </div>
                      <img
                        src={VerticalLine}
                        alt="vertical line"
                        className={`mx-2 h-full max-h-full`}
                      />
                      <div className="flex flex-col items-center space-y-3 max-w-[75%]">
                        <img src={__renderTitleByNameRunning()} alt="" className="scale-95 w-fit" />
                        <img
                          src={HorizontalSplitLine}
                          alt="horizontal line"
                          className={`h-full max-h-full`}
                        />
                        {/* <img
                          src={TitleSplitTopRank}
                          alt=""
                          className="object-contain w-fit max-w-[90%]"
                        /> */}
                        <img
                          src={__renderSubTitleByNameRunning()}
                          alt=""
                          className="object-contain w-fit max-w-[90%]"
                        />
                      </div>
                    </div>
                  )}

                {Array.isArray(x?.relatedItems) && x.relatedItems.length > 0 ? (
                  <div
                    className={`${checkShopStardamGroup ? (Math.abs(width - height) < 500 ? 'h-[calc(100vh-120px)]' : 'h-[calc(100vh-95px)]') : 'h-screen'} ${Math.abs(width - height) < 500 ? 'w-full' : 'w-1/2'}  mx-auto`}
                  >
                    <div className="flex w-full h-full border-t-2 border-white border-solid border-x-2">
                      <div className="border-r border-white h-full w-[42%]">
                        {getShowRankingTop(top1) !== 1 ? (
                          <>
                            {_renderRank({
                              name: top1?.nick_name,
                              id: top1?.id,
                              img:
                                width === height
                                  ? `images_rank_shop_${selectShop?.id}_position_0_${top1?.id}_1.jpg`
                                  : `images_rank_shop_${selectShop?.id}_position_0_${top1?.id}_2.jpg`,
                              noteRanking: top1,
                              rank: 'No.1',
                              style: {
                                sizeBox: { width: '100%', height: '100%' },
                                sizeTextName: 32,
                                sizeTextPosition: 24,
                                sizeTextRank: 24,
                                padding: 32,
                                borderRightWidth: 1,
                                borderColor: '#FFFFFF',
                                borderTopWidth: 1,
                                borderBottomWidth: 1,
                              },
                            })}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="grid grid-rows-2 w-[26%] h-full">
                        {top2_3?.map((item: any, idx: number) => (
                          <div
                            key={idx}
                            className={`${top2_3.length > 0 && 'border-b last:border-b-0'} border-white border-r`}
                          >
                            {getShowRankingTop(item) !== 1 && (
                              <>
                                {_renderRank({
                                  name: item?.nick_name,
                                  id: item?.id,
                                  img:
                                    width === height
                                      ? `images_rank_shop_${selectShop?.id}_position_${
                                          idx === 0 ? 1 : 2
                                        }_${item?.id}_1.jpg`
                                      : `images_rank_shop_${selectShop?.id}_position_${
                                          idx === 0 ? 1 : 2
                                        }_${item?.id}_2.jpg`,
                                  noteRanking: item,
                                  rank: idx === 0 ? 'No.2' : 'No.3',
                                  style: {
                                    sizeBox: { width: '100%', height: '100%' },
                                    sizeTextName: 24,
                                    sizeTextPosition: 18,
                                    sizeTextRank: 18,
                                    padding: 16,
                                    borderRightWidth: 1,
                                    borderColor: '#FFFFFF',
                                    borderTopWidth: 1,
                                    paddingRight: 10,
                                    paddingBottom: 10,
                                    scale: 3,
                                  },
                                })}
                              </>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="flex flex-col w-[32%] h-full">
                        <div className="flex flex-1 w-full h-full max-h-[calc(100%/3)]">
                          {top4_5?.map((item: any, idx: number) => (
                            <div
                              key={idx}
                              className={`${
                                idx === 0
                                  ? top4_5?.length === 1
                                    ? 'border-r'
                                    : 'border-r'
                                  : 'border-l'
                              } border-white border-b w-1/2`}
                            >
                              {getShowRankingTop(item) !== 1 && (
                                <>
                                  {_renderRank({
                                    name: item?.nick_name,
                                    id: item?.id,
                                    img:
                                      width === height
                                        ? `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 3 : 4
                                          }_${item?.id}_1.jpg`
                                        : `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 3 : 4
                                          }_${item?.id}_2.jpg`,

                                    noteRanking: item,
                                    rank: idx === 0 ? 'No.4' : 'No.5',
                                    style: {
                                      sizeBox: { width: '100%', height: '100%' },
                                      sizeTextName: 18,
                                      sizeTextPosition: 16,
                                      sizeTextRank: 16,
                                      padding: 8,
                                      borderRightWidth: 1,
                                      borderColor: '#FFFFFF',
                                      borderTopWidth: 1,
                                      borderBottomWidth: 1,
                                      paddingRight: 6,
                                    },
                                  })}
                                </>
                              )}
                            </div>
                          ))}
                        </div>

                        <div
                          className={`${
                            top6_7?.length === 0
                              ? top4_5?.length === 2
                                ? ''
                                : top4_5?.length === 1
                                  ? ''
                                  : ''
                              : 'border-white border-t flex w-full h-full max-h-[calc(100%/3)]'
                          }`}
                        >
                          {top6_7?.map((item: any, idx: number) => (
                            <div
                              key={idx}
                              className={`${
                                idx === 0
                                  ? top6_7?.length === 1
                                    ? 'border-r'
                                    : 'border-r'
                                  : 'border-l'
                              } border-b border-white w-1/2`}
                            >
                              {getShowRankingTop(item) !== 1 && (
                                <>
                                  {_renderRank({
                                    name: item?.nick_name,
                                    id: item?.id,
                                    img:
                                      width === height
                                        ? `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 5 : 6
                                          }_${item?.id}_1.jpg`
                                        : `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 5 : 6
                                          }_${item?.id}_2.jpg`,
                                    noteRanking: item,
                                    rank: idx === 0 ? 'No.6' : 'No.7',
                                    style: {
                                      sizeBox: { width: '100%', height: '100%' },
                                      sizeTextName: 18,
                                      sizeTextPosition: 16,
                                      sizeTextRank: 16,
                                      padding: 16,
                                      borderRightWidth: 1,
                                      borderColor: '#FFFFFF',
                                      borderTopWidth: 1,
                                      borderBottomWidth: 1,
                                      paddingRight: 6,
                                    },
                                  })}
                                </>
                              )}
                            </div>
                          ))}
                        </div>

                        <div className="flex w-full h-full max-h-[calc(100%/3)]">
                          {top8_9_10?.map((item: any, idx: number) => (
                            <div
                              key={idx}
                              className={`${
                                idx === 0
                                  ? 'border-r'
                                  : idx === 1
                                    ? 'border-l border-r'
                                    : 'border-l'
                              } border-white w-1/3`}
                            >
                              {getShowRankingTop(item) !== 1 && (
                                <>
                                  {_renderRank({
                                    name: item?.nick_name,
                                    id: item?.id,
                                    img:
                                      width === height
                                        ? `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 7 : idx === 1 ? 8 : 9
                                          }_${item?.id}_1.jpg`
                                        : `images_rank_shop_${selectShop?.id}_position_${
                                            idx === 0 ? 7 : idx === 1 ? 8 : 9
                                          }_${item?.id}_2.jpg`,
                                    noteRanking: item,

                                    rank: idx === 0 ? 'No.8' : idx === 1 ? 'No.9' : 'No.10',
                                    style: {
                                      sizeBox: { width: '100%', height: '100%' },
                                      sizeTextName: 18,
                                      sizeTextPosition: 16,
                                      sizeTextRank: 16,
                                      padding: 16,
                                      borderRightWidth: 1,
                                      borderColor: '#FFFFFF',
                                      borderTopWidth: 1,
                                      borderBottomWidth: 1,
                                      col: true,
                                      scale: '2',
                                      paddingRight: 20,
                                      paddingBottom: 14,
                                    },
                                  })}
                                </>
                              )}
                            </div>
                          ))}
                          {top8_9_10?.length === 1 && (
                            <div className="h-full !w-[2.5px] bg-white"></div>
                          )}
                          {top8_9_10?.length === 2 && (
                            <div className="h-full !w-[2.5px] bg-white"></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="relative w-full h-screen">{__renderStandByImage(x)}</div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
export default memo(LayoutRow);
